import MessageBox from "@/components/common/messagebox/MessageBox.vue";
import TableField from "@/components/common/table-field/TableField.vue";

const defaultEl = {
    clientId: null,
    name: null,
    totalAmount: 0,
    objects: [],
    sessionsStripe: null
}
export default {
    name: 'StripeForm',
    components: {
        TableField,
        MessageBox
    },

    data() {
        return {
            loading: false,
            client: defaultEl
        }
    },

    computed: {
        columns() {
            return [
                { title: this.$t('stripeForm.object'), key: "vehicleNumbers", minWidth: "250px", maxWidth: "800px", align: "justify" },
                { title: this.$t('stripeForm.quantity'), key: "quantity", minWidth: "80px" },
                { title: this.$t('stripeForm.objectPrice'), key: "oneObjectPrice", minWidth: "60px" },
                { title: this.$t('stripeForm.ObjectTotalPrice'), key: "totalRowPrice", minWidth: "100px" },
            ]
        },

        companyId() {
            return this.$store.state.companyId;
        },
    },

    methods: {
        async populateData() {
            this.loading = true;
            try {
                const { data } = await this.getPayment();
                if (data) {
                    this.client = data.client == null ? defaultEl : this.BasicHelper.cloneObject(data.client);
                }
            } finally {
                this.loading = false;
            }
        },

        async getPayment() {
            return await this.ApiRequest.requestAsync(
                `billing/payment/${this.companyId}`,
                this.ApiRequest.REQUEST_GET,
                [],
                'billing-payment',
                true
            );
        },

        async subscribe() {
            this.loading = true;
            try {
                const { data } = await this.getSubscribe();
                if (data) {
                    window.location.replace(data.url);
                }
            } finally {
                this.loading = false;
            }
        },

        async getSubscribe() {
            return this.ApiRequest.requestAsync(
                `stripe/subscribe/${this.client.clientId}`,
                this.ApiRequest.REQUEST_GET,
                [],
                'stripe-subscribe',
                true
            );
        },

        async sendMessageUnsubscribe(el = null, approved = false) {
            if (approved) {
                this.loading = true;
                try {
                    const { data } = await this.getUnsubscribe();
                    if (data) {
                        this.client.sessionsStripe.is_subscription = data.is_subscription;
                    }
                } finally {
                    this.loading = false;
                }
            } else {
                this.$refs.sendMsgUnsubscribeBox.show(
                    el,
                    null,
                    this.$t('stripeForm.text-unsubscribe', { date: this.client.sessionsStripe.period_end }),
                    this.$t('stripeForm.btn-cancel'),
                    this.$t('stripeForm.btn-confirm')
                );
            }
        },

        async getUnsubscribe() {
            return this.ApiRequest.requestAsync(
                `stripe/unsubscribe/${this.client.clientId}`,
                this.ApiRequest.REQUEST_GET,
                [],
                'stripe-unsubscribe',
                true
            );
        },
    },

    beforeMount() {
        this.populateData();
    },

    watch: {
        companyId() {
            this.populateData();
        }
    }
}
